import React from "react";

interface ListItemProps {
  className?: string;
  title: string;
  description: string;
}
export const ListItem = ({ className, title, description }: ListItemProps) => {
  return (
    <div className={className ? className : ""}>
      <h3 className="font-medium text-xl mb-2">{title}</h3>
      <p className="break-words">{description}</p>
    </div>
  );
};
